import {Observable} from 'rxjs';
import {CpmCOO8ConnectorApiModel} from '../../models/c-global/cpmc-oo8-connector.api-model';
import {
    CpmCOO8ConnectorCreateApiSchema,
    CpmCOO8ConnectorUpdateApiSchema
} from '../../schemas/c-global/cpmc-oo8-connector.api-schemas';
import {CpmCApiBridge} from '../../../../../src/app/cpmc-api-bridge';
import {CpmCQueryPaginatorConfig, CpmCQueryPaginatorConfigUtils} from '../../cpmc-defines';
import {AllowedQueryParamTypes, QueryParams} from '../../../../../sdk/src/utils/query.utils';
import {CpmCPaginatedResultAPISchema} from '../../schemas/cpmc-paginated-result.api-schemas';

export type CpmCGetOO8ConnectorListParams = {
    [K in keyof CpmCOO8ConnectorApiModel]?: CpmCOO8ConnectorApiModel[K] extends AllowedQueryParamTypes
        ? CpmCOO8ConnectorApiModel[K]
        : never;
} & {} & QueryParams;

/**
 * OO8Connector Api Service
 */
export class CpmCOO8ConnectorApiService {
    public static readonly dPaginatorConfig: CpmCQueryPaginatorConfig = {limit: -1, sort: 'name', order: 1};

    // ===============================================================
    // ===============================================================

    public static baseUrl() {
        return CpmCApiBridge.getBackendBaseURL() + 'api/core/v1/oo8-connector';
    }

    // ===============================================================
    // ===============================================================

    public static endpointList(): string {
        return `${CpmCOO8ConnectorApiService.baseUrl()}/list`;
    }
    public static endpointNew(): string {
        return `${CpmCOO8ConnectorApiService.baseUrl()}`;
    }
    public static endpointGet(oo8ConnectorUUID: string): string {
        return `${CpmCOO8ConnectorApiService.baseUrl()}/${oo8ConnectorUUID}`;
    }
    public static endpointEdit(oo8ConnectorUUID: string): string {
        return `${CpmCOO8ConnectorApiService.baseUrl()}/${oo8ConnectorUUID}`;
    }
    public static endpointDelete(oo8ConnectorUUID: string): string {
        return `${CpmCOO8ConnectorApiService.baseUrl()}/${oo8ConnectorUUID}`;
    }

    // ===============================================================
    // ===============================================================

    public static getOO8ConnectorList(
        params: CpmCGetOO8ConnectorListParams = {},
        paginatorConfig: CpmCQueryPaginatorConfig = CpmCOO8ConnectorApiService.dPaginatorConfig
    ): Observable<CpmCPaginatedResultAPISchema<CpmCOO8ConnectorApiModel>> {
        return CpmCApiBridge.httpGet<CpmCPaginatedResultAPISchema<CpmCOO8ConnectorApiModel>>(
            CpmCOO8ConnectorApiService.endpointList(),
            {
                ...(params as QueryParams),
                ...CpmCQueryPaginatorConfigUtils.toQueryParams(paginatorConfig)
            }
        );
    }
    public static getOO8ConnectorByUUID(oo8ConnectorUUID: string): Observable<CpmCOO8ConnectorApiModel> {
        return CpmCApiBridge.httpGet<CpmCOO8ConnectorApiModel>(
            CpmCOO8ConnectorApiService.endpointGet(oo8ConnectorUUID)
        );
    }
    public static createOO8Connector(payload: CpmCOO8ConnectorCreateApiSchema): Observable<CpmCOO8ConnectorApiModel> {
        return CpmCApiBridge.httpPost<CpmCOO8ConnectorApiModel>(CpmCOO8ConnectorApiService.endpointNew(), payload);
    }
    public static updateOO8Connector(
        oo8ConnectorUUID: string,
        payload: CpmCOO8ConnectorUpdateApiSchema
    ): Observable<CpmCOO8ConnectorApiModel> {
        return CpmCApiBridge.httpPut<CpmCOO8ConnectorApiModel>(
            CpmCOO8ConnectorApiService.endpointEdit(oo8ConnectorUUID),
            payload
        );
    }
    public static deleteOO8Connector(oo8ConnectorUUID: string): Observable<boolean> {
        return CpmCApiBridge.httpDelete<boolean>(CpmCOO8ConnectorApiService.endpointDelete(oo8ConnectorUUID));
    }
}
